export const formData = {
    address: '', // 详细地址
    locationDistrict: '', // 省市区名称
    addressInfo: '', // 省市区编码
    expectedDeliveryTime: '', // 预计时间
    remark: '' // 备注
};

export const formRules = {
    addressInfo: [
        {
            required: true,
            message: '请选择地址',
            trigger: 'blur'
        }
    ],
    address: [
        {
            required: true,
            message: '请输入详细地址',
            trigger: 'blur'
        },
        { max: 30, message: '长度不能超过30个字符' }
    ]
};
